import { ADVANCED, BRANDING, PROGRESS_TRACKER } from '@opengov/stories-shared/constants';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React from 'react';

import { IStoriesSettingsMessages } from '../../../../types';
import { styles } from './SideNav.styles';

export type ISideNavProps = {
  messages: IStoriesSettingsMessages;
  activeTab: string;
  setActiveTab(tab: string): void;
  showProgressTracker?: boolean;
};

export const SideNav = ({ messages, activeTab, setActiveTab, showProgressTracker }: ISideNavProps) => {
  return (
    <Tabs value={activeTab} onChange={(_e, value) => setActiveTab(value)} aria-label={messages.settings} sx={styles.tabs}>
      <Tab value={BRANDING} label={messages.branding} data-test="branding-nav" />
      <Tab value={ADVANCED} label={messages.advanced} data-test="advanced-nav" />
      {showProgressTracker && (
        <Tab value={PROGRESS_TRACKER} label={messages.progressTracker} data-test="progress-tracker-nav" />
      )}
    </Tabs>
  );
};
